// @flow
import React from 'react';
import type { Element } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { StyledCover } from './styles';

import type { Props } from '../../types';

const PrimaryButton = (props: Props): Element<any> => {
  const {
    href, label, onClick, className, disabled, loading
  }: Props = props;

  return (
    <StyledCover
      href={href}
      onClick={!loading && onClick}
      className={className}
      disabled={disabled}
    >
      {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : label}
    </StyledCover>
  );
};

export default PrimaryButton;
